import { gql } from "@apollo/client";

export const MeetingsOverviewMeeting = gql`
  fragment MeetingsOverviewMeeting on MeetingNode {
    id
    title
    description
    draft
    meetingGroupId
    ignored
    videoConferenceType
    videoConferenceUrl
    startDatetime
    endDatetime
    isRecurring
    hasBotInMeeting
    botIsRecording
    botIsWaitingToJoinMeeting
    canRead {
      permission
      reason
    }
    canUpdate {
      permission
      reason
    }
    canDelete {
      permission
      reason
    }
    organizer {
      id
      name
    }
    meetingGroup {
      id
      title
      description
      isFormalOneonone
      addTranscriptionBotToMeetingsByDefault
      transcribeMeetingsByDefault
      facilitator {
        id
        name
        avatar
      }
      topicTemplate {
        id
      }
      syncCredentials {
        id
        credentialsUid
      }
      onlineConference
    }
    creator {
      id
    }
    participants {
      totalCount
      edges {
        node {
          id
          status
          participantEmail
          role
          user {
            id
            name
            firstName
            lastName
            avatar
            email
            status
          }
        }
      }
    }
  }
`;
